<EXP__glxy-wrap dense>
  <span class="time-span__row">
    <ng-container *ngIf="!disableTimeSelectors">
      <forms-time-picker
        (hasAnyErrors)="handleHasAnyErrors($event, endTimeHasErrors)"
        [control]="startTime"
        [include24Hours]="true"
        [includeNotesOnly]="isHolidayHours"
        (onBlur)="blur(startTime)"
        [placeholder]="'FRONTEND.FORMS.HOURS_OF_OPERATION.OPENS_AT' | translate"
        [appearance]="'outline'"
      ></forms-time-picker>
      <span class="divider" *ngIf="!allDay && !notesOnly">&#8212;</span>
      <forms-time-picker
        (hasAnyErrors)="handleHasAnyErrors(startTimeHasErrors, $event)"
        [control]="endTime"
        *ngIf="!allDay && !notesOnly"
        (onBlur)="blur(endTime)"
        [placeholder]="'FRONTEND.FORMS.HOURS_OF_OPERATION.CLOSES_AT' | translate"
        [appearance]="'outline'"
      ></forms-time-picker>
    </ng-container>
    <ng-container *ngIf="disableTimeSelectors">
      <span class="notes-only-display">
        {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.NOTES_ONLY' | translate }}
      </span>
    </ng-container>
    <div class="delete-button" *ngIf="allowDelete">
      <button mat-icon-button [color]="'primary'" (click)="deleteCallback()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </span>
  <span *ngIf="!allDay && !(notesOnly && isHolidayHours)" class="time-span__row_error_message">
    <mat-error [innerHTML]="errorMessage"></mat-error>
  </span>
  <span class="time-span__row" *ngIf="isHolidayHours">
    <mat-form-field class="time-span__description" [appearance]="'outline'">
      <input
        matInput
        [placeholder]="'FRONTEND.FORMS.HOURS_OF_OPERATION.NOTES' | translate"
        [value]="value.description || ''"
        (change)="value.description = $event.target.value"
      />
    </mat-form-field>
  </span>
  <span *ngIf="value.description && !(notesOnly && isHolidayHours)" class="time-span__row_error_message">
    <mat-error [innerHTML]="'FRONTEND.FORMS.HOURS_OF_OPERATION.DESCRIPTION_WILL_BE_REMOVED' | translate"></mat-error>
  </span>
</EXP__glxy-wrap>
